import * as validators from './formValidators'

export const required = validators.required
export const onlyNumber = validators.onlyNumber
export const greaterThan0 = validators.greaterThan0
export const greaterThanNinePointFive = validators.greaterThanNinePointFive
export const atLeastThreeCharacters = validators.atLeastThreeCharacters
export const noNumericCharacters = validators.noNumericCharacters
export const isValidEmail = validators.isValidEmail
export const isValidName = validators.isValidName
export const passwordHasValidLength = validators.passwordHasValidLength
export const isValidPhoneNumber = validators.isValidPhoneNumber
export const phoneNumberHasValidLength = validators.phoneNumberHasValidLength
export const isValidDescription = validators.isValidDescription
export const isValidSocialSecurityNumber = validators.isValidSocialSecurityNumber
export const curriculumHasValidType = validators.curriculumHasValidType
export const pictureHasValidType = validators.pictureHasValidType
export const qualificationFileHasValidType = validators.qualificationFileHasValidType
export const identityDocumentFileHasValidType = validators.identityDocumentFileHasValidType
export const fileHasValidType = validators.fileHasValidType
export const isValidDate = validators.isValidDate
export const selectionRequired = validators.selectionRequired
export const equalTo5 = validators.equalTo5
export const formatNif = validators.formatNif
export const validNif = validators.validNif
export const validNie = validators.validNie
export const validIban = validators.validIban
export const lessThan100 = validators.lessThan100
export const isValidPostalCode = validators.isValidPostalCode
export const isUnderage = validators.isUnderage



// WEBPACK FOOTER //
// ./src/utils/formValidators/formValidators.default.ts